import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
// 非遗定制弹窗  数据对接非遗项目
import { handleHttp } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      rightTopflag: false,
      query: {},
      iframeurl: '',
      linkcontainerflag: false
    };
  },
  watch: {
    '$attrs.detail'(val) {
      if (val) {}
    }
  },
  mounted() {
    this.query = this.$route.query;
    // query.formUserId === '1083493444' 武汉非遗地图 更换所在区字段 做匹配 20251106
  },
  methods: {
    get47data(data) {
      let result = '';
      if (data) {
        result = data.map(item => {
          return item.val;
        }).join('、');
      }
      return result;
    },
    // 跳转
    goLink(url) {
      this.linkcontainerflag = true;
      this.iframeurl = url;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = "";
    }
  }
};